import { render, staticRenderFns } from "./searchArticles.vue?vue&type=template&id=0546807a&scoped=true&"
import script from "./searchArticles.vue?vue&type=script&lang=js&"
export * from "./searchArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0546807a",
  null
  
)

export default component.exports